export const labelClassName = "block text-sm font-medium text-gray-700 mb-1";

// fallback in case some legacy code still references it
export const inputClassName =
  "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none";
